/** Sort complaint API rows by a date field (asc = oldest first). */
export function sortComplaintsByDateField(complaints, order, dateField) {
  return [...complaints].sort((a, b) => {
    const dateA = new Date(a[dateField]);
    const dateB = new Date(b[dateField]);
    return order === "asc" ? dateA - dateB : dateB - dateA;
  });
}

/** Grid row order: preserve user sort, else default serial order. */
export function orderComplaintsForGrid(complaints, sortOrder) {
  if (sortOrder != null) {
    return complaints;
  }
  return [...complaints].sort((a, b) => a.Serial_No - b.Serial_No);
}
